import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { List } from 'antd';
import { ProList, ProTable, ProCard } from '@ant-design/pro-components';
import Icon, { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import CardIcon from './icons/card.svg';
import TableIcon from './icons/table.svg';
import ResizableTitle from './ResizableTitle';
import './style.less';
const modeBars = [
    {
        key: 'TABLE_STYLE',
        icon: TableIcon,
        mode: 'table'
    },
    {
        key: 'CARD_STYLE',
        icon: CardIcon,
        mode: 'card'
    }
];
export const FreeTableList = (props) => {
    const [columns, setColumns] = useState([]);
    const [currentMode, setCurrentMode] = useState('table');
    const [hidePagination, setHidePagination] = useState(false);
    const options = {
        className: `free-table-list ${props.className || ''}`,
        rowKey: props.rowKey || 'id',
        metas: (() => {
            const metas = {};
            props.columns?.forEach(column => {
                metas[column.dataIndex] = column;
            });
            return metas;
        })(),
        toolbar: {
            ...(props.toolbar || {}),
            actions: [
                ...(props.toolbar?.actions || [])
            ].concat(props.mode === 'both' ?
                modeBars.map(({ key, icon, mode }) => {
                    return _jsx(Icon, { component: icon, className: `${mode}-icon ${mode === currentMode ? 'active' : ''}`, onClick: () => setCurrentMode(mode) }, key);
                }) : [])
        },
        search: props.search === false ? false : {
            labelWidth: 'auto',
            optionRender(_, __, doms) {
                return doms?.map((dom) => {
                    const isSubmit = dom?.key === 'submit';
                    return React.cloneElement(dom, {
                        type: isSubmit ? 'primary' : '',
                        ghost: !!isSubmit,
                        icon: isSubmit ? _jsx(SearchOutlined, {}) : _jsx(ReloadOutlined, {})
                    });
                });
            },
            ...(props.search || {})
        },
        pagination: props.pagination === false ? false : {
            defaultPageSize: 10,
            defaultCurrent: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            className: `ant-pagination-${hidePagination ? 'hide' : 'show'}`,
            showTotal: (total) => {
                if (!total !== hidePagination) {
                    setHidePagination(!total);
                }
                return _jsxs("span", { children: ["\u5171 ", total, " \u6761\u8BB0\u5F55"] });
            },
            size: 'default',
            ...(props.pagination || {}),
        },
        scroll: { scrollToFirstRowOnChange: true, x: true },
        tableStyle: { ...props.tableStyle, ...(props.search === false ? { paddingTop: 24 } : {}) }
    };
    const serialSchema = props?.serial === false
        ? []
        : [{
                title: '序号',
                search: false,
                width: 64,
                render: (_, __, index, { pageInfo }) => {
                    const { current = 1, pageSize = 10 } = pageInfo || {};
                    return (current - 1) * pageSize + (index + 1);
                },
                ...(props?.serial === true ? {} : props?.serial),
            }];
    useEffect(() => {
        if (props.columns && !columns?.length) {
            setColumns(props.columns);
        }
    }, [props.columns, columns]);
    return (currentMode === 'card' && props.mode === 'both') || props.mode === 'card' ?
        _jsx(ProList, { ...props, ...options, params: (props.params || {}), grid: { gutter: 24, column: 3, ...(props.grid || {}) }, renderItem: (item, index) => {
                const renderItem = props.renderItem?.(item, index);
                return (_jsx(List.Item, { children: _jsx(ProCard, { bordered: true, ...(renderItem?.cardProps || {}), children: renderItem?.render() }) }, item.id));
            } }) :
        _jsx(ProTable, { ...props, ...options, size: "large", options: false, columns: [...serialSchema, ...columns].map((column) => ({
                ...column,
                onCell: () => ({
                    width: column.width,
                }),
                onHeaderCell: () => ({
                    width: column.width,
                    onResize: (width) => {
                        column.width = width;
                        setColumns([...columns]);
                    }
                })
            })), components: {
                header: {
                    cell: ResizableTitle
                },
                body: {
                    cell: (props) => (_jsx("td", { ...props, style: { ...props.style, maxWidth: parseFloat(props.width || 0) + 32 } }))
                },
            } });
};
export default FreeTableList;
